import { apiClient } from '@shared/utils/api-client';
import type { Review } from '../types';

export const REVIEWS_PAGE_SIZE = 25;

export type ReviewsModerationFilter = 'all' | 'pending' | 'approved' | 'rejected';

export type ReviewsListQuery = {
  page: number;
  limit?: number;
  moderation?: ReviewsModerationFilter;
  productIds?: number[];
  sellerIds?: number[];
  ratings?: number[];
  hasPhotos?: boolean;
  dateFrom?: string;
  dateTo?: string;
};

export type ReviewsListPage = {
  items: Review[];
  total: number;
  page: number;
  limit: number;
};

export const reviewsApi = {
  getAll: async (query: ReviewsListQuery): Promise<ReviewsListPage> => {
    const params = new URLSearchParams();
    params.set('page', String(query.page));
    params.set('limit', String(query.limit ?? REVIEWS_PAGE_SIZE));
    if (query.moderation && query.moderation !== 'all') {
      params.set('moderation', query.moderation);
    }
    query.productIds?.forEach((id) => params.append('productId', String(id)));
    query.sellerIds?.forEach((id) => params.append('sellerId', String(id)));
    query.ratings?.forEach((rating) => params.append('rating', String(rating)));
    if (query.hasPhotos) params.set('hasPhotos', 'true');
    if (query.dateFrom) params.set('dateFrom', query.dateFrom);
    if (query.dateTo) params.set('dateTo', query.dateTo);
    return apiClient.get<ReviewsListPage>(`/reviews?${params.toString()}`);
  },

  getNewCount: async (): Promise<{ count: number }> => {
    return apiClient.get<{ count: number }>('/reviews/new/count');
  },

  setApproval: async (id: number, approved: boolean): Promise<Review> => {
    return apiClient.patch<Review>(`/reviews/${id}/approval`, { approved });
  },

  setSellerReplyApproval: async (
    id: number,
    approved: boolean,
  ): Promise<Review> => {
    return apiClient.patch<Review>(`/reviews/${id}/seller-reply/approval`, {
      approved,
    });
  },

  adminReply: async (id: number, text: string): Promise<Review> => {
    return apiClient.post<Review>(`/reviews/${id}/admin-reply`, { text });
  },

  delete: async (id: number): Promise<{ success: boolean }> => {
    return apiClient.delete<{ success: boolean }>(`/reviews/${id}`);
  },
};
